module.exports = __webpack_public_path__ + "static/media/Registration Certificate.822905cf.pdf";